import React from 'react';
import { observer } from 'mobx-react';
import { ConceptStore } from '@seedlang/stores';
import TypeAhead from 'components/type_ahead';
import { isEmpty } from 'lodash';

@observer
class ConceptSearch extends React.Component {

  static defaultProps = {
    searchByField: 'name',
    placeholder: 'Search for Concept',
  };

  componentDidMount() {
    ConceptStore.setSort(this.props.searchByField);
    if (this.props.languageId) {
      ConceptStore.setFilter('language_id', this.props.languageId);
    }
  }

  componentWillUnmount() {
    this.onClear();
  }

  onKeyUp(value) {
    if (isEmpty(value)) {
      this.onClear();
    } else {
      ConceptStore.setFilter(this.props.searchByField, `~${value}~`, { refresh: true });
    }
  }

  onSelect(obj) {
    this.props.onSubmit(obj);
  }

  onClear() {
    ConceptStore.clearIndexData();
    ConceptStore.clearFilter();
    if (this.props.languageId) {
      ConceptStore.setFilter('language_id', this.props.languageId);
    }
  }

  render() {
    return (
      <div className='concept-search'>
        <TypeAhead
          onKeyUp={this.onKeyUp.bind(this)}
          onSelect={this.onSelect.bind(this)}
          onClear={this.onClear.bind(this)}
          options={ConceptStore.indexData}
          displayField={this.props.displayField || this.props.searchByField}
          placeholder={this.props.placeholder}
        />
      </div>
    );
  }
}

export default ConceptSearch;
